module.exports = __webpack_public_path__ + "img/icon_branco.14509a70.png";